import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private savedProgressTime = 0;
  public savedProgressTime$ = new BehaviorSubject<number>(0);

  setSavedProgressTime(time: number): void {
    this.savedProgressTime = time;
    this.savedProgressTime$.next(time);
  }

  getSavedProgressTime(): number {
    return this.savedProgressTime;
  }

  clearSavedProgressTime(): void {
    this.savedProgressTime = 0;
    this.savedProgressTime$.next(0);
  }

  private answeredQuestions = new Set<number>();
  public answeredQuestions$ = new BehaviorSubject<Set<number>>(new Set<number>());

  addAnsweredQuestion(id: number): void {
    this.answeredQuestions.add(id);
    this.answeredQuestions$.next(this.answeredQuestions);
  }

  hasAnsweredQuestion(id: number): boolean {
    return this.answeredQuestions.has(id);
  }

  clearAnsweredQuestions(): void {
    this.answeredQuestions.clear();
    this.answeredQuestions$.next(this.answeredQuestions);
  }

  private showAnswers = false;
  public showAnswers$ = new BehaviorSubject<boolean>(false);

  setShowAnswers(show: boolean): void {
    this.showAnswers = show;
    this.showAnswers$.next(show);
  }

  getShowAnswers(): boolean {
    return this.showAnswers;
  }

  private replayVideo = false;
  public replayVideo$ = new BehaviorSubject<boolean>(false);

  setReplayVideo(replay: boolean): void {
    this.replayVideo = replay;
    this.replayVideo$.next(replay);
  }

  getReplayVideo(): boolean {
    return this.replayVideo;
  }

  private playVideo = false;
  public playVideo$ = new BehaviorSubject<boolean>(false);

  setPlayVideo(play: boolean): void {
    this.playVideo = play;
  }

  getPlayVideo(): boolean {
    return this.playVideo;
  }

  private resumeVideo: number | null = null;
  public resumeVideo$ = new BehaviorSubject<number | null>(null);

  setResumeVideo(time: number): void {
    this.resumeVideo = time;
    this.resumeVideo$.next(time);
  }

  getResumeVideo(): number | null {
    return this.resumeVideo;
  }

  private hasSavedProgress = false;
  public hasSavedProgress$ = new BehaviorSubject<boolean>(false);

  setHasSavedProgress(hasSaved: boolean): void {
    this.hasSavedProgress = hasSaved;
    this.hasSavedProgress$.next(hasSaved);
  }

  getHasSavedProgress(): boolean {
    return this.hasSavedProgress;
  }

  private playingVideo = false;
  public playingVideo$ = new BehaviorSubject<boolean>(false);

  setPlayingVideo(playing: boolean): void {
    this.playingVideo = playing;
    this.playingVideo$.next(playing);
  }

  clearPlayingVideo(): void {
    this.playingVideo = false;
    this.playingVideo$.next(false);
  }

  private modelOpen = false;
  public modelOpen$ = new BehaviorSubject<boolean>(false);

  setModelOpen(open: boolean): void {
    this.modelOpen = open;
    this.modelOpen$.next(open);
  }

  getModelOpen(): boolean {
    return this.modelOpen;
  }


  private videoCompleted = false;
  public videoCompleted$ = new BehaviorSubject<boolean>(false);

  setVideoCompleted(completed: boolean): void {
    this.videoCompleted = completed;
    this.videoCompleted$.next(completed);
  }

  getVideoCompleted(): boolean {
    return this.videoCompleted;
  }
 
}
